module.exports = __webpack_public_path__ + "img/crm_section_icon-1.16750152.png";